// src/pages/HomePage.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './homePage.css';
export default function HomePage() {
  const [workTime, setWorkTime] = useState(30);
  const [restTime, setRestTime] = useState(15);
  const [sets, setSets] = useState(3);
  const navigate = useNavigate();
  const totalSeconds =
    (parseInt(workTime || 0, 10) + parseInt(restTime || 0, 10)) *
    parseInt(sets || 0, 10);

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formattedTime = `${minutes} mins ${seconds
    .toString()
    .padStart(2, '0')} sec`;
  const handleStart = () => {
    navigate(`/timer?work=${workTime}&rest=${restTime}&sets=${sets}`);
  };

  return (
    <div className='home-container'>
      <div className='home-card'>
        <h2 className='home-heading'>Interval Timer Setup</h2>
        <div className='input-group'>
          <label className='input-label'>Work Time (sec): </label>
          {[20, 30, 40, 45].map((sec) => (
            <button
              key={sec}
              className={`option-button ${workTime === sec ? 'selected' : ''}`}
              onClick={() => setWorkTime(sec)}
            >
              {sec}
            </button>
          ))}
        </div>
        <div className='input-group'>
          <label className='input-label'>Rest Time (sec): </label>
          {[10, 15, 20, 25].map((sec) => (
            <button
              key={sec}
              className={`option-button ${restTime === sec ? 'selected' : ''}`}
              onClick={() => setRestTime(sec)}
            >
              {sec}
            </button>
          ))}
        </div>
        <div className='input-group'>
          <label className='input-label'>Sets: </label>
          <input
            type='number'
            value={sets}
            onChange={(e) => setSets(e.target.value)}
            className='input-field'
          />
        </div>
        <div className='total-time'>
          <strong>Total Time:</strong> {formattedTime}
        </div>
        <button onClick={handleStart} className='start-button'>
          Start
        </button>
      </div>
    </div>
  );
}
